import api from '../../api/distributors'
import Vue from 'vue'
import {
  DISTRIBS_LIST,
  DISTRIBS_ADD,
  DISTRIBS_UPDATE,
  DISTRIBS_DELETE,
  DISTRIBS_SINGLE,
  DISTRIBS_BY_COUNTRY
} from '../actions/distributors'

const state = {
  distributors: []
}

const getters = {
  distributors: state => {
    return state.distributors || []
  },
  distributorsById (state) {
    return id => state.distributors.filter(item => {
      return item.id === parseInt(id)
    })
  }
}

const actions = {
  [DISTRIBS_LIST]: async function ({commit, state}) {
    if (state.distributors.length) {
      return 200
    }
    try {
      const res = await api.getAllDistributors()
      commit(DISTRIBS_LIST, res)
      return res.status
    } catch (err) {
      console.log(err)
      return err.response.status
    }
  },
  [DISTRIBS_ADD]: async function ({commit}, distributor) {
    try {
      const res = await api.addDistributor(distributor)
      commit(DISTRIBS_ADD, {distributor: res[0]})
      return res
    } catch (err) {
      console.log(err)
      return null
    }
  },
  [DISTRIBS_UPDATE]: async function ({state, commit}, params) {
    try {
      const distributor = await api.updateDistributor(params.id, params.distributor)
      for (let i = 0; i < state.distributors.length; i++) {
        if (state.distributors[i].id === distributor[0].id) {
          commit(DISTRIBS_UPDATE, {i, distributor: distributor[0]})
          break
        }
      }
      return distributor
    } catch (err) {
      console.log(err)
      return null
    }
  },
  [DISTRIBS_DELETE]: async function ({state, commit}, params) {
    try {
      const distributor = await api.deleteDistributor(params.id)
      for (let i = 0; i < state.distributors.length; i++) {
        if (state.distributors[i].id === distributor[0].id) {
          commit(DISTRIBS_DELETE, { i })
          break
        }
      }
      return distributor
    } catch (err) {
      console.log(err)
      return null
    }
  },
  [DISTRIBS_SINGLE]: async function ({state, commit, dispatch}, params) {
    if (!state.distributors.length) {
      await dispatch(DISTRIBS_LIST)
    }
    try {
      const distributor = await api.getSingleDistributor(params.id)
      for (let i = 0; i < state.distributors.length; i++) {
        if (state.distributors[i].id === distributor[0].id) {
          commit(DISTRIBS_UPDATE, { i, distributor: distributor[0] })
          break
        }
      }
      return distributor
    } catch (err) {
      console.log(err)
      return null
    }
  },
  [DISTRIBS_BY_COUNTRY]: async function ({state, dispatch}, params) {
    if (!state.distributors.length) {
      await dispatch(DISTRIBS_LIST)
    }
    return state.distributors.filter(item => {
      const d = item.countries.filter(country => {
        return country.id === params.countryId
      })
      return d[0]
    })
  }
}

const mutations = {
  [DISTRIBS_LIST]: (state, params) => {
    Vue.set(state, 'distributors', params.data.data)
  },
  [DISTRIBS_UPDATE]: (state, params) => {
    state.distributors[params.i] = params.distributor
  },
  [DISTRIBS_ADD]: (state, params) => {
    state.distributors.unshift(params.distributor)
  },
  [DISTRIBS_DELETE]: (state, params) => {
    state.distributors.splice(params.i, 1)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/distributors.js